import React from "react";
import { LegalLayout, LegalSection } from "./LegalLayout";

export const Datenschutz = () => (
  <LegalLayout
    eyebrow="Rechtliches"
    title="Datenschutzerklärung"
    testId="datenschutz-page"
  >
    <LegalSection title="1. Allgemeine Hinweise">
      <p>
        Der Schutz Ihrer persönlichen Daten ist uns wichtig. Wir behandeln Ihre
        personenbezogenen Daten vertraulich und entsprechend den gesetzlichen
        Datenschutzvorschriften sowie dieser Datenschutzerklärung.
      </p>
    </LegalSection>

    <LegalSection title="2. Verantwortlicher">
      <p>
        Pflegeheld Handels GmbH
        <br />
        Bahnhofstraße 71
        <br />
        31515 Wunstorf
        <br />
        Deutschland
      </p>
      <p>
        E-Mail:{" "}
        <a
          href="mailto:info@pflege-box-gratis.de"
          className="text-[#3FA66D] hover:underline break-all"
        >
          info@pflege-box-gratis.de
        </a>
        <br />
        Telefon:{" "}
        <a href="tel:+4917670157687" className="text-[#3FA66D] hover:underline">
          0176 70157687
        </a>
      </p>
    </LegalSection>

    <LegalSection title="3. Erhebung und Speicherung personenbezogener Daten">
      <p>
        Beim Besuch unserer Website werden automatisch Informationen durch den
        Hosting-Anbieter erfasst. Dies sind insbesondere:
      </p>
      <ul className="list-disc pl-6 space-y-1">
        <li>IP-Adresse</li>
        <li>Datum und Uhrzeit der Anfrage</li>
        <li>Browsertyp und Browserversion</li>
        <li>Verwendetes Betriebssystem</li>
        <li>Referrer-URL</li>
      </ul>
      <p>
        Diese Daten dienen ausschließlich der technischen Bereitstellung und
        Sicherheit unserer Website. Eine Zusammenführung dieser Daten mit
        anderen Datenquellen findet nicht statt. Rechtsgrundlage ist Art. 6
        Abs. 1 lit. f DSGVO (berechtigtes Interesse an der technisch
        fehlerfreien Darstellung und Optimierung unserer Website).
      </p>
    </LegalSection>

    <LegalSection title="4. Kontaktformular">
      <p>
        Wenn Sie uns über das Kontaktformular Anfragen zukommen lassen, werden
        Ihre Angaben aus dem Anfrageformular inklusive der von Ihnen dort
        angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage und für den
        Fall von Anschlussfragen bei uns gespeichert. Die Verarbeitung erfolgt
        auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO (Vertrag bzw.
        vorvertragliche Maßnahmen) sowie Art. 6 Abs. 1 lit. a DSGVO
        (Einwilligung).
      </p>
    </LegalSection>

    <LegalSection title="5. Ihre Rechte">
      <p>
        Sie haben jederzeit das Recht auf Auskunft (Art. 15 DSGVO),
        Berichtigung (Art. 16), Löschung (Art. 17), Einschränkung der
        Verarbeitung (Art. 18), Datenübertragbarkeit (Art. 20) sowie
        Widerspruch (Art. 21). Zudem können Sie eine erteilte Einwilligung
        jederzeit widerrufen und sich bei einer Aufsichtsbehörde beschweren
        (Art. 77 DSGVO).
      </p>
    </LegalSection>

    <LegalSection title="6. Speicherdauer">
      <p>
        Personenbezogene Daten werden nur so lange gespeichert, wie dies für
        die Zweckerreichung erforderlich ist oder gesetzliche
        Aufbewahrungsfristen es vorschreiben.
      </p>
    </LegalSection>

    <LegalSection title="7. SSL-Verschlüsselung">
      <p>
        Diese Website nutzt aus Sicherheitsgründen eine SSL-Verschlüsselung.
        Eine verschlüsselte Verbindung erkennen Sie an „https://" in der
        Adresszeile Ihres Browsers.
      </p>
    </LegalSection>
  </LegalLayout>
);

export default Datenschutz;
